import React, { Component, Fragment } from 'react'
import { BreadCrumb, Card } from '../../components'
import { Translate } from '../../contexts/Language'
import { Config } from '../../config';
import { Service } from '../../services';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';

export class Profile extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            formData: {
                firstName: "",
                lastName: "",
                password: null,
                passwordConfirm: null
            },
            validation: {
                error: false,
                message: ""
            },
        }
    }
    componentDidMount() {
        Config.utilities.loadingFetch();

        Service.User.Profile().then(response => {
            if (response) {


                this.setState(prevState => ({
                    formData: { ...prevState.formData, firstName: response.firstName, lastName: response.lastName }
                }));


            }

            Config.utilities.loadingFetch();
        });
    }
    onFormChange(value, key) {

        let formData = this.state.formData;

        formData[key] = value;

        this.setState({
            formData
        });
    }
    onSaveProfile() {


        if (this.isValid(this.state.formData)) {
            Config.utilities.loadingFetch();

            Service.User.SaveProfile(this.state.formData).then(response => {

                if (response.error) {
                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                }

                Config.utilities.loadingFetch();
            });
        }
    }
    isValid(data) {


        VRules["firstName"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("First Name can not be empty.")
        }
        VRules["lastName"] = {
            Invalid: (value) => {
                return VConditions.Required(value)
            },
            Message: Translate("Last Name can not be empty.")
        }

        VRules["password"] = {
            Invalid: (value) => {
                return (VConditions.MinLength(value, 6) && value !== "")
            },
            Message: Translate("Password length must be minimum 6 characters.")
        }

        VRules["passwordConfirm"] = {
            Invalid: (value) => {
                return (VConditions.MinLength(value, 6) && value !== "")
            },
            Message: Translate("Password length must be minimum 6 characters.")
        }

        let error = Validator.Valid(data, this.Refs);

        if (!error.error) {
            if (data.password !== data.passwordConfirm) {
                error = {
                    error: true,
                    message: "Check your password"
                }
            } else {
                error = {
                    error: false,
                    message: ""
                }
            }
            console.log(data);
        }

        this.setState({
            validation: error
        });



        return !error.error;
    }
    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Profile")} Name={Translate("Profile")} />
                <Card Title={Translate("Profile")} Description={Translate("Sets profile information")}>
                    <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                        <ErrorMessage Validation={this.state.validation} />
                        <div className="form-group row ml-1">
                            <label htmlFor="firstName" className="col-sm-2 col-form-label">First Name</label>
                            <div className="col-sm-4">
                                <input className="form-control" type="text" id="firstName" name="firstName" value={this.state.formData.firstName} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                            </div>
                        </div>
                        <div className="form-group row ml-1">
                            <label htmlFor="lastName" className="col-sm-2 col-form-label">Last Name</label>
                            <div className="col-sm-4">
                                <input className="form-control" type="text" id="lastName" name="lastName" value={this.state.formData.lastName} onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                            </div>
                        </div>
                        <div className="form-group row ml-1 mt-5">
                            <label htmlFor="password" className="col-sm-2 col-form-label">Password</label>
                            <div className="col-sm-4">
                                <input className="form-control" type="password" id="password" name="password" autoComplete="new-password" onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                            </div>
                        </div>
                        <div className="form-group row ml-1">
                            <label htmlFor="passwordConfirm" className="col-sm-2 col-form-label">Password Confirm</label>
                            <div className="col-sm-4">
                                <input className="form-control" type="password" id="passwordConfirm" name="passwordConfirm" autoComplete="new-password" onChange={(e) => this.onFormChange(e.target.value, e.target.name)} />
                            </div>
                        </div>
                        <div className="form-group row ml-1 pt-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-4">
                                <button type="button" className="btn btn-info" onClick={(e) => this.onSaveProfile()}><i className="far fa-save mr-1"></i> Save Profile</button>
                            </div>
                        </div>
                    </form>
                </Card>
            </Fragment>
        )
    }
}